import React from 'react';
export function Footer() {
  return <footer className="bg-[#050508] border-t border-white/5 py-12" data-id="element-76">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-77">
        <p className="text-brand-muted text-sm mb-4" data-id="element-78">
          © {new Date().getFullYear()} David Miller. Todos los derechos
          reservados.
        </p>
        <p className="text-xs text-gray-600 max-w-2xl mx-auto leading-relaxed" data-id="element-79">
          DESCARGO DE RESPONSABILIDAD: Este producto es un recurso educativo e
          informativo. No pretende diagnosticar, tratar, curar o prevenir
          ninguna enfermedad. La información proporcionada no sustituye el
          consejo médico profesional. Consulta siempre a tu médico antes de
          comenzar cualquier nuevo régimen de dieta, ejercicio o suplementos.
          Los resultados pueden variar de persona a persona.
        </p>
      </div>
    </footer>;
}